import { GraphQLResult } from "@aws-amplify/api";
import { API } from "aws-amplify";
import { Dispatch, DispatchWithoutAction, SetStateAction } from "react";
import { toast } from 'react-toastify';

import { deletePlant } from "../../../graphql/mutations";
import { updateLoading } from "../../../redux/slice/appSlice";
import { AppDispatch } from "../../../redux/store";
import { DeletePlantMutation, Plant } from "../../../types/api";

interface deletePlantByIdProps {
  id: string | undefined;
  index: number;
  dispatch: AppDispatch;
  updatePlants: Dispatch<SetStateAction<(Plant | null)[]>>;
  forceUpdate: DispatchWithoutAction;
}
export const deletePlantById: ({
  id,
  index,
  dispatch,
  updatePlants,
  forceUpdate
}: deletePlantByIdProps) => Promise<void> = async ({
  id,
  index,
  dispatch,
  updatePlants,
  forceUpdate
}: deletePlantByIdProps) => {
  try {
    dispatch(updateLoading(true));
    const deleteResponse: GraphQLResult<DeletePlantMutation> =
      await API.graphql({
        query: deletePlant,
        variables: { input: { id } }
      }) as GraphQLResult<DeletePlantMutation>;
    if (deleteResponse.data?.deletePlant) {
      updatePlants((prevState) => {
        if (prevState) {
          prevState.splice(index, 1);
        }
        return prevState;
      });
      forceUpdate();
    }
  } catch (err) {
    // console.log(err)
    toast.dark("Error: Delete Plant.");
  } finally {
    dispatch(updateLoading(false));
  }
};
